import { Component, HostListener, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService, UtilsService } from 'src/app/shared/services';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.less']
})
export class ThankYouComponent implements OnInit {
  isHandset: boolean;
  roomId: string;
  height: number;
  isloading = true;

  constructor(private utilService: UtilsService, private router: Router,
    private apiService: ApiService,
    private snackBar: MatSnackBar,
    private actRouter: ActivatedRoute,

  ) {
    this.roomId = this.actRouter.snapshot.params.id;
    this.height = window.innerHeight;

  }

  getDeisgnProject() {
    this.isloading = true;
    const user = JSON.parse(localStorage.getItem("user"));
    this.apiService.getAllAppointments("", "", user.id).subscribe((res) => {
      if (res && res.length > 0) {
        if (res.length === 1 && res[0].status == '02') {
          this.roomId = res[0].room_id;
        } else { 
        }
      } else {
        this.snackBar.open('No rooms found!','x');
        this.router.navigate(['/']);
      }
      this.isloading = false;

    }, err => {
      this.isloading = false;

    });
  }

  ngOnInit(): void {
    this.getDeisgnProject();
    this.utilService.isHandset().subscribe(resp => {
      this.isHandset = resp.matches
    });
  }
  goToRoom() {
    if (this.roomId) {
      this.router.navigate([`/room-profile/${this.roomId}/inspiration`])
    } else {
      this.router.navigate(['/design/rooms'])
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.height = window.innerHeight;

  }
}
